
export const config = {
  basename: '/',
  defaultPath: '/',
  fontFamily: `'MADE TOMMY', sans-serif`,
  borderRadius: 12
};
